import $ from 'jquery';
import { observeProperty } from "@lts-web/utils/ObjectUtil";

const propNameToDataAttribute = propName => `data-${propName}`;
const dataAttributeToPropName = dataAttribute => dataAttribute.replace(/^data-/, '');

class PureComponent {
    constructor (selector, props = {}) {
        this._selector = selector;
        this.props = props;
    }

    static filterProperty (key, value) {
        return value;
    }

    /**
     * @returns {Array}
     */
    static get properties () {
        return [];
    }

    /**
     * @returns {Array}
     */
    static get observedAttributes () {
        return this.properties.map(propNameToDataAttribute);
    }

    /**
     * @returns {jQuery|HTMLElement}
     */
    get element () {
        return $(this._selector);
    }

    connectedCallback () {
        this.assignAttributes();
    }

    attributeChangedCallback (attrName, newValue, oldValue) {
        let propValue = newValue;
        const propName = dataAttributeToPropName(attrName);

        try {
            propValue = JSON.parse(propValue);
        } catch (e) {}

        if (newValue !== oldValue) {
            this.props[propName] = propValue;
        }
    }

    observeProperty (key, callback, defaultVal = this.props[key]) {
        return observeProperty(this.props, key, callback.bind(this), defaultVal);
    }

    assignAttributes () {
        const ctor = this.constructor;
        const data = this.element.data();

        ctor.properties.forEach((property) => {
            if (data.hasOwnProperty(property)) {
                this.props[property] = ctor.filterProperty(property, data[property]);
            }
        });
    }
}

export default PureComponent;